/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSyncEntitiesByDisplayDateRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {GetSyncEntitiesByDisplayDateResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const getSyncEntitiesByDisplayDate = (request:GetSyncEntitiesByDisplayDateRequest, options?: CashRequestOptions) => post<GetSyncEntitiesByDisplayDateRequest, GetSyncEntitiesByDisplayDateResponse>("/2.0/cash/get-sync-entities-by-display-date", request, {...options, rejectOnError: true })